export default "__VITE_ASSET__e37f028e__"